import { AddRemoveButton, LinkButton, Space } from '../../atoms'
import Icon from '../../atoms/Icon'
import { NumberInput } from '../../atoms/number-input'
import { Percent } from '../../atoms/percent'
import { StyledAssetTable } from './primitives'

export type TransferAsset = {
  id: string
  name: string
  return: number
  units?: number
  volatility: number
  weight?: number
}

export type AssetTableTransferProps = {
  assets?: TransferAsset[]
  onChangeAssetUnits: (id: string, units: number) => void
  onClickAsset?: (id: string) => void
  onRemoveAsset: (id: string) => void
}

export function AssetTableTransfer({
  assets,
  onChangeAssetUnits,
  onClickAsset,
  onRemoveAsset
}: AssetTableTransferProps) {
  return (
    <StyledAssetTable>
      <thead>
        <tr>
          <th className="asset">Asset</th>
          <th className="return">Return</th>
          <th className="volatility">Volatility</th>
          <th className="weight">Weight (%)</th>
          <th className="units">Units</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(assets) &&
          assets.map(asset => (
            <tr key={asset.name}>
              <td className="asset">
                {onClickAsset !== undefined ? (
                  <LinkButton underline onClick={() => onClickAsset(asset.id)}>
                    {asset.name}
                  </LinkButton>
                ) : (
                  asset.name
                )}
              </td>
              <td className="return">
                <Percent
                  fixed
                  highlightPnl
                  numDecimalPlaces={2}
                  value={asset.return === null ? null : asset.return * 100}
                />
              </td>
              <td className="volatility">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={asset.volatility === null ? null : asset.volatility * 100}
                />
              </td>
              <td className="weight">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={asset.weight === null ? null : asset.weight * 100}
                />
              </td>
              <td className="units">
                <Space isflex alignItems="center">
                  <NumberInput
                    value={asset.units === null || asset.units === 0 ? '' : asset.units}
                    onChange={v => onChangeAssetUnits(asset.id, Number(v.target.value))}
                  />
                  <AddRemoveButton
                    isDisabled={false}
                    operationType="remove"
                    onClick={() => onRemoveAsset(asset.id)}
                  >
                    <Space isflex alignItems="center" justifyContent="center">
                      <Icon name="remove" size="small" />
                    </Space>
                  </AddRemoveButton>
                </Space>
              </td>
            </tr>
          ))}
      </tbody>
    </StyledAssetTable>
  )
}
